import adaptive from './adaptive'

const install = function (Vue) {
  Vue.directive('el-height-adaptive-table', adaptive)
}

adaptive.install = install
export default adaptive
